const e = { aria_label: "Sök", clear: "Rensa", placeholder_article: "", placeholder_header: "Sök efter artiklar" }, a = {
  searcher: e
};
export {
  a as default,
  e as searcher
};
//# sourceMappingURL=help-center-articles-search43.js.map
